import { render } from "./GemMechanism10Win.vue?vue&type=template&id=4aa76226&scoped=true"
const script = {}

import "./GemMechanism10Win.vue?vue&type=style&index=0&id=4aa76226&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4aa76226"]])

export default __exports__